document.addEventListener('DOMContentLoaded', function() {
  setInterval(function() {
    const shippingText = document.getElementsByClassName("cart-drawer__shipping-title")[0];

    // Check if the element exists
    if (shippingText) {
      const innerHTMLContent = shippingText.innerHTML;

      // Check if the text contains "free standard shipping" 
      if (innerHTMLContent.includes("free standard shipping") ) {
        const modifiedHTML = innerHTMLContent.replace("free standard shipping", 
          '<span id="cart-shipping-text">free standard shipping</span>'
        );
        shippingText.innerHTML = modifiedHTML;
      }
    }
  }, 1000);  // Check every 1 second
}, false);
